import { Component } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { InputTextComponent } from 'src/app/shared/component/input-text/input-text.component';
import { LoadingButtonComponent } from 'src/app/shared/component/loading-button/loading-button.component';
import { Router } from '@angular/router';
import { finalize } from 'rxjs';
import { MESSAGES } from 'src/app/core/constant/messages';
import { UserRole } from 'src/app/core/enum/user-role.enum';
import { AuthData } from 'src/app/shared/model/session';
import { AuthService } from 'src/app/shared/service/auth.service';
import { ToastService } from 'src/app/shared/service/toast.service';
import { BaseFormComponent } from 'src/app/shared/form/base-form.component';

declare const grecaptcha: any;

@Component({
  selector: 'app-login',
  imports: [
    LoadingButtonComponent,
    InputTextComponent,
    FormsModule,
    ReactiveFormsModule,
  ],
  templateUrl: './login-admin.component.html',
})
export class LoginAdminComponent extends BaseFormComponent {
  loginForm!: FormGroup;
  loading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    toastService: ToastService,
    private router: Router
  ) {
    super(toastService);
    this.initLoginForm();
  }

  private initLoginForm(): void {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
    });
  }

  onSubmit(): void {
    if (!this.validateForm(this.loginForm)) return;

    this.loading = true;

    grecaptcha.ready(() => {
      grecaptcha
        .execute('6LcUwHMaAAAAAIUn-5HQ25qU1FhSR4zUVoGmqOvt', {
          action: 'login_admin',
        })
        .then((token: string) => {
          this.authenticateAdmin(token);
        })
        .catch(() => {
          this.loading = false;
          this.toastService.showMessages('error', [
            'No se pudo validar el reCAPTCHA. Intenta nuevamente.',
          ]);
        });
    });
  }

  private authenticateAdmin(recaptchaToken: string): void {
    const { email, password } = this.loginForm.value;

    this.authService
      .login(email, password, recaptchaToken)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (res) => this.handleLoginSuccess(res.dto),
        error: (err) => this.handleLoginError(err),
      });
  }

  private handleLoginSuccess(auth: AuthData): void {
    if (!auth?.token) {
      this.toastService.showMessages('error', [
        MESSAGES.AUTH.INVALID_CREDENTIALS,
      ]);
      return;
    }

    if (auth.status !== 'authenticated') {
      this.toastService.showMessages('error', [
        MESSAGES.AUTH.ADMIN_NOT_AUTHENTICATED,
      ]);
      return;
    }

    if (!auth.user?.roles?.includes(UserRole.ADMINISTRADOR)) {
      this.toastService.showMessages('error', [MESSAGES.AUTH.ADMIN_NO_ROLE]);
      return;
    }

    this.toastService.showMessages('success', [
      MESSAGES.AUTH.ADMIN_LOGIN_SUCCESS,
    ]);
    this.router.navigate(['/admin']);
  }

  private handleLoginError(err: any): void {
    this.showApiError(err, MESSAGES.AUTH.LOGIN_ERROR);
  }
}
